import { api } from 'services/api';
import { createRestProvider } from './restProvider';

export const toursDataProvider = createRestProvider();

interface TourApi {
  id: number;
  productCode?: string;
  isActivated?: boolean;
  name?: string;
  nameXhr?: string;
  locality?: string;
  address4?: string;
  address5?: string;
  code6?: string;
  code6Description?: string;
  productClass?: string;
  classDescription?: string;
  includedBreakfast?: boolean;
  includedLunch?: boolean;
  includedDinner?: boolean;
  description?: string;
  xhr?: string;
  startLocation?: string;
  endLocation?: string;
  startTimes?: string[];
  endTimes?: string[];
}

/** Maps the REST shape onto the field names the (Hasura-era) form binds to. */
const fromApi = (tour: TourApi) => ({
  id: tour.id,
  product_code: tour.productCode,
  is_active: tour.isActivated,
  name: tour.name,
  name_xhr: tour.nameXhr,
  locality: tour.locality,
  address4: tour.address4,
  address5: tour.address5,
  code6: tour.code6,
  code6_description: tour.code6Description,
  product_class: tour.productClass,
  class_description: tour.classDescription,
  included_breakfast: tour.includedBreakfast,
  included_lunch: tour.includedLunch,
  included_dinner: tour.includedDinner,
  description: tour.description,
  tour: {
    id: tour.id,
    xhr: tour.xhr,
    start_location: tour.startLocation,
    end_location: tour.endLocation,
    start_time: tour.startTimes || [],
    end_time: tour.endTimes || []
  }
});

toursDataProvider.getOne = async ({ id }) => {
  const { data } = await api.get<{ data: TourApi }>(`/admin/tours/${id}`);
  return { data: fromApi(data) as any };
};

toursDataProvider.update = async ({ variables, id }) => {
  const values = (variables || {}) as Record<string, any>;
  const tour = values.tour || {};

  const { data } = await api.patch<{ data: TourApi }>(`/admin/tours/${id}`, {
    name: values.name,
    locality: values.locality,
    address4: values.address4,
    address5: values.address5,
    code6: values.code6,
    code6Description: values.code6_description,
    productClass: values.product_class,
    classDescription: values.class_description,
    description: values.description,
    includedBreakfast: values.included_breakfast,
    includedLunch: values.included_lunch,
    includedDinner: values.included_dinner,
    xhr: tour.xhr,
    startLocation: tour.start_location,
    endLocation: tour.end_location,
    startTimes: tour.start_time,
    endTimes: tour.end_time
  });

  return { data: fromApi(data) as any };
};
